import { installClickTracking } from "./trackClicks";

function isAdmin() {
  const w = window as unknown as { __IS_ADMIN__?: boolean };
  const path = window.location.pathname;
  return w.__IS_ADMIN__ || path === "/admin" || path.startsWith("/admin/") || path === "/admin-login";
}

export function startClickTracking() {
  if (typeof window === "undefined" || isAdmin()) return;

  // Keep the supplied tracker unchanged while guarding clicks after SPA navigation.
  // Only its synchronous listener registration is wrapped; normal registration is restored.
  const original = document.addEventListener;
  document.addEventListener = function (type, listener, options) {
    if (type === "click" && typeof listener === "function") {
      const guarded: EventListener = (event) => {
        if (!isAdmin()) listener.call(document, event);
      };
      original.call(document, type, guarded, options);
    } else {
      original.call(document, type, listener, options);
    }
  };
  try {
    installClickTracking();
  } finally {
    document.addEventListener = original;
  }
}